import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { fetchOrders } from '../actions';
import { getOrder } from '../reducer';
import ReEdit from './ReEdit';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var dashboard = _ref.dashboard;
  var match = _ref2.match;
  return {
    externalId: match.params.externalId,
    order: getOrder({
      dashboard: dashboard,
      match: match
    })
  };
};
var mapDispatchToProps = {
  fetchOrders: fetchOrders
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReEdit));